import React, { Component } from 'react';


export class ContactForm extends Component {

    constructor(props) {
        super(props);
        this.state = { commentValue: "", commentReceived: false, commentResponse: "", commentFailed: false };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    CommentAck() {
        return <div className="alert alert-success" role="alert" >Your comment has been sent - thank you. An agent will be in touch shortly.</div>;
    }

    CommentFailed() {
        return <div className="alert alert-danger" role="alert" >Your comment could not be sent. Please call us on {this.props.quoteData.brandPhone}.</div>;
    }


    handleChange(event) {
        this.setState({ commentValue: event.target.value });
    }

    handleSubmit(event) {
        let fullCommentUrl = `${this.props.quoteData.quoteTargetUrl}${this.props.quoteData.commentFunction}`;
        let commentData = {
            brandId: this.props.quoteData.brandId,
            leadId: this.props.quoteData.reference,
            comment: this.state.commentValue
        };

        event.preventDefault();
        if (!this.state.commentValue || this.state.commentValue.trim().length === 0) {
            return;
        }

        console.log(`Posting comment to ${fullCommentUrl}`);

        fetch(fullCommentUrl, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(commentData)

        }).then(response => {
                if (response.ok) {
                    response.json()
                        .then(data => {
                            this.setState({ commentResponse: data, commentReceived: true });
                        });
                } else {
                    this.setState({ commentFailed: true });
                    throw new Error("failed to upload comment");
                }
            })
            .catch(err => {
                this.setState({ commentFailed: true });
                console.error(err.message);
            });

    }

    render() {
        return (
            <form id="frmcontact" name="frmcontact" className="hidden-print" onSubmit={this.handleSubmit}>
                <div className="form-group">
                    <label htmlFor="notes">Comments</label>
                    <textarea className="form-control" rows="3" name="notes" id="notes" value={this.state.commentValue} onChange={this.handleChange} placeholder="If you have any comments or questions, please enter them here and click the submit button &mdash; I'll get back to you as soon as possible with an answer."/>
                </div>
                {this.state.commentReceived ? this.CommentAck() : null}
                {this.state.commentFailed ? this.CommentFailed() : null}
                <input type="submit" value="Submit Comments" className="btn btn-primary"  />
            </form>
        );
    }
}